module.exports = __webpack_public_path__ + "static/media/1007030.f81516ad.jpg";